<template>

  <v-container fluid class="page page-vehicle-list">

    <!-- Breadcrumb & Actions -->
    <v-row class="mt-4 mb-8">
      <v-col sm="8" class="d-flex align-center justify-start page-breadcrumb-new">
        <v-icon small class="mr-2">mdi-car</v-icon>
        <div>Vehicles</div>
      </v-col>
      <v-col sm="4" align="right">
        <!-- (add vehicle action) -->
        <v-btn color="light-blue darken-1" @click="createDraft">
          Add Vehicle
        </v-btn>
      </v-col>
    </v-row>

    <!-- Page Content -->
    <v-container fluid class="px-0">
      <!-- Vehicle List -->
      <vehicle-list-data-table />
    </v-container>

  </v-container>

</template>

<script>
import VehicleListDataTable from '@/components/vehicles/VehicleListDataTable'

export default {
  name: 'VehicleListPage',

  components: {
    VehicleListDataTable
  },

  computed: {
  },

  methods: {
    async createDraft () {
      const draft = await this.$store.dispatch('sh/createDraft', {
        resource: 'vehicle',
        data: { vehicle_status: 'AT_HQ' }
      })
      this.$store.dispatch('sh/setItemToEdit', draft) // set item to edit
      this.$root.goTo('vehicle-item-new') // go to item new page
    }
  }
}
</script>

<style scoped>
  /* .page-vehicle-list .page-content-data {
    padding: 0;
  } */
</style>
